export const footerCodeConstDefault = {
  Eng: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6 text-justify">
          The information in this website does not represent an insurance contract; it only provides general information about the Life (Term and Universal Life): Limitations and exclusions apply. Critical Illness: Limitations, exclusions and waiting periods may apply. This product is not appropriate for people who are eligible for Medicaid coverage.
        </p>
        <p class="text-center lg:text-left text-[14px]">
          American Fidelity International Ltd.
        </p>
        <p class="mb-6 text-center lg:text-left">
         
          <a href="/terms">
            <u>Terms of Use</u>
          </a>
          |
          <a href="/privacy">
            <u>Privacy Policy</u>
          </a>
          |
          <a href="/secure">
            <u>Secure Computing Practices</u>
          </a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">
          Design by <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
          <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
        </p>  
        <p class="mb-6 text-center lg:text-left text-[14px]">ESB-9773-1125</p>
      </div> 
    </div>`,
  Es: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6 text-justify">
          La información de este sitio web no representa un contrato de seguro; solo proporciona información general sobre Vida (Temporal y Universal): Se aplican limitaciones y exclusiones. Enfermedades Críticas: Pueden aplicarse limitaciones, exclusiones y períodos de espera. Este producto no es apropiado para personas elegibles para la cobertura de Medicaid.
        </p>
        <p class="text-center lg:text-left text-[14px]">
          American Fidelity International Ltd.
        </p>
        <p class="mb-6 text-center lg:text-left">
         
          <a href="/terms">
            <u>Términos de Uso</u>
          </a>
          |
          <a href="/privacy">
            <u>Política de Privacidad</u>
          </a>
          |
          <a href="/secure">
            <u>Prácticas de Navegación Segura</u>
          </a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">
          Diseño de <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
          <a href="https://www.wemarkforyou.com/" target="_blank">Www.wemarkforyou.com</a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">ESB-9773-1125</p>  
      </div>
    </div>`,
  Pu: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6">
          Limitações, exclusões e períodos de espera podem ser aplicados.
        </p>
        <p class="mb-6 text-justify">
          As informações contidas neste site não representam um contrato de seguro, apenas fornecem informações gerais sobre o Ultra III (Apólice de Seguro de Vida Ajustável de Prêmio Flexível, FPAL132B), Prime (Apólice de Seguro de Vida Ajustável de Prêmio Flexível, FPAL17B) e o Index Pro IUL (Apólice de Seguro de Vida Universal Indexada de Prêmio Flexível Ajustável, FPAIUL20B). Para mais informações, contacte o seu consultor e consulte as condições específicas da apólice. Limitações da apólice, exclusões e períodos de espera e cláusulas adicionais podem ser aplicados.
        </p>
        <p class="text-center lg:text-left text-[14px]">
          ©2024 American Fidelity International Ltd. - Todos os direitos reservados
        </p>
        <p class="mb-6 text-center lg:text-left">
         
          <a href="/terms">
            <u>Termos de Uso</u>
          </a>
          |
          <a href="/privacy">
            <u>Política de Privacidade</u>
          </a>
          |
          <a href="/secure">
            <u>Práticas de Navegação Segura</u>
          </a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">
          Design por <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
          <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
        </p>  
        <p class="mb-6 text-center lg:text-left text-[14px]">ESB-9773-1125</p>
      </div>
    </div>`,
};

export const footerCodeConstHome = {
  Eng: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm ">
          <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Footnotes</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
           The information in this website does not represent an insurance contract; it only provides general information about the Life (Term and Universal Life): Limitations and exclusions apply. Critical Illness: Limitations, exclusions and waiting periods may apply. This product is not appropriate for people who are eligible for Medicaid coverage.
          </p>
          <p class="text-center lg:text-left text-[14px]">
            American Fidelity International Ltd.
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Terms of Use</u>
            </a>
            |
            <a href="/privacy">
              <u>Privacy Policy</u>
            </a>
            |
            <a href="/secure">
              <u>Secure Computing Practices</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Design by <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9736-1125</p>
        </div>
      </div>`,
  Es: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm ">
          <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Notas de pie de página</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
            La información de este sitio web no representa un contrato de seguro; solo proporciona información general sobre Vida (Temporal y Universal): Se aplican limitaciones y exclusiones. Enfermedades Críticas: Pueden aplicarse limitaciones, exclusiones y períodos de espera. Este producto no es apropiado para personas elegibles para la cobertura de Medicaid.
          </p>
          <p class="text-center lg:text-left text-[14px]">
           American Fidelity International Ltd.
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Términos de Uso</u>
            </a>
            |
            <a href="/privacy">
              <u>Política de Privacidad</u>
            </a>
            |
            <a href="/secure">
              <u>Prácticas de Navegación Segura</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Diseño de <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9736(Span.)-1125</p>
        </div>
      </div>`,
  Pu: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm ">
          <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Rodapé</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
            As informações neste site não representam um contrato de seguro; fornecem apenas informações gerais sobre a Apólice de Seguro de Vida Temporário (TL04B.R710). Para mais informações, entre em contato com seu consultor e consulte as condições específicas da apólice. Podem aplicar-se limitações, exclusões e adicionais da apólice.
          </p>
          <p class="text-center lg:text-left text-[14px]">
            ©2024 American Fidelity International Ltd. - Todos os direitos reservados
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Termos de Uso</u>
            </a>
            |
            <a href="/privacy">
              <u>Política de Privacidade</u>
            </a>
            |
            <a href="/secure">
              <u>Práticas de Navegação Segura</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Design por <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9737-1125</p>
        </div>
      </div>`,
};

export const footerCodeConstAbout = {
  Eng: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm ">
          <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Footnotes</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
           The information in this website does not represent an insurance contract; it only provides general information about the Life (Term and Universal Life): Limitations and exclusions apply. Critical Illness: Limitations, exclusions and waiting periods may apply. This product is not appropriate for people who are eligible for Medicaid coverage.
          </p>
          <p class="text-center lg:text-left text-[14px]">
            American Fidelity International Ltd.
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Terms of Use</u>
            </a>
            |
            <a href="/privacy">
              <u>Privacy Policy</u>
            </a>
            |
            <a href="/secure">
              <u>Secure Computing Practices</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Design by <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9737-1125</p>
        </div>
      </div>`,
  Es: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm ">
          <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Notas de pie de página</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
            La información de este sitio web no representa un contrato de seguro; solo proporciona información general sobre Vida (Temporal y Universal): Se aplican limitaciones y exclusiones. Enfermedades Críticas: Pueden aplicarse limitaciones, exclusiones y períodos de espera. Este producto no es apropiado para personas elegibles para la cobertura de Medicaid.
          </p>
          <p class="text-center lg:text-left text-[14px]">
           American Fidelity International Ltd.
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Términos de Uso</u>
            </a>
            |
            <a href="/privacy">
              <u>Política de Privacidad</u>
            </a>
            |
            <a href="/secure">
              <u>Prácticas de Navegación Segura</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Diseño de <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9737(Span.)-1125</p>
        </div>
      </div>`,
  Pu: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm ">
          <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Rodapé</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
            As informações neste site não representam um contrato de seguro; fornecem apenas informações gerais sobre a Apólice de Seguro de Vida Temporário (TL04B.R710). Para mais informações, entre em contato com seu consultor e consulte as condições específicas da apólice. Podem aplicar-se limitações, exclusões e adicionais da apólice.
          </p>
          <p class="text-center lg:text-left text-[14px]">
            ©2024 American Fidelity International Ltd. - Todos os direitos reservados
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Termos de Uso</u>
            </a>
            |
            <a href="/privacy">
              <u>Política de Privacidade</u>
            </a>
            |
            <a href="/secure">
              <u>Práticas de Navegação Segura</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Design por <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9737-1125</p>
        </div>
      </div>`,
};

export const footerCodeConstCompare = {
  Eng: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm ">
          <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Footnotes</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
            The information in this website does not represent an insurance contract, it only provides general information.
          </p>
          <p class="mb-6 text-justify">Term, Universal Life and Indexed Universal Life: Limitations and exclusions may apply.</p>
          <p class="mb-6 text-justify">Critical Illness: Limitations, exclusions and waiting periods may apply.</p>
          <p class="text-justify">“The"S&P 500 Index"is a product of S&P Dow Jones Indices LLC or its affiliates (“SPDJI”) and has been licensed for use by American Fidelity International Ltd. (the "Company"). Standard & Poor’s® and S&P® are registered trademarks of Standard & Poor’s Financial Services LLC (“S&P”) and Dow Jones® is a registered trademark of Dow Jones Trademark Holdings LLC (“Dow Jones”). The trademarks have been licensed to SPDJI and have been sublicensed for use for certain purposes by the Company. The Flexible Premium Adjustable Indexed Universal Life Insurance Policy (the "Product") is not sponsored, endorsed, sold or promoted by SPDJI, Dow Jones, S&P, any of their respective affiliates (collectively, “S&P Dow Jones Indices”). S&P Dow Jones Indices does not make any representation or warranty, express or implied, to the owners of the Product or any member of the public regarding the advisability of investing in securities generally or in the Product particularly or the ability of the S&P 500 Index to track general market performance. S&P Dow Jones Indices only relationship to the Company with respect to the S&P 500 Index is the licensing of the Index and certain trademarks, service marks and/or trade names of S&P Dow Jones Indices and/or its licensors. The S&P 500 Index is determined, composed and calculated by S&P Dow Jones Indices without regard to the Company or the Product. S&P Dow Jones Indices has no obligation to take the needs of the Company or the owners of the Product into consideration in determining, composing or calculating the S&P 500 Index. S&P Dow Jones Indices is not responsible for and has not participated in the determination of the prices, and amount of the Product or the timing of the issuance or sale of the Product or in the determination or calculation of the equation by which the Product is to be converted into cash, surrendered or redeemed, as the case may be. S&P Dow Jones Indices has no obligation or liability in connection with the administration, marketing or trading of the Product. There is no assurance that investment products based on the S&P 500 Index will accurately track index performance or provide positive investment returns. S&P Dow Jones Indices LLC is not an investment advisor. Inclusion of a security within an index is not a recommendation by S&P Dow Jones Indices to buy, sell, or hold such security, nor is it considered to be investment advice. </p>

<p class="mt-4 text-justify">S&P DOW JONES INDICES DOES NOT GUARANTEE THE ADEQUACY, ACCURACY, TIMELINESS AND/OR THE COMPLETENESS OF THE S&P 500 INDEX OR ANY DATA RELATED THERETO OR ANY COMMUNICATION, INCLUDING BUT NOT LIMITED TO, ORAL OR WRITTEN COMMUNICATION (INCLUDING ELECTRONIC COMMUNICATIONS) WITH RESPECT THERETO. S&P DOW JONES INDICES SHALL NOT BE SUBJECT TO ANY DAMAGES OR LIABILITY FOR ANY ERRORS, OMISSIONS, OR DELAYS THEREIN. S&P DOW JONES INDICES MAKES NO EXPRESS OR IMPLIED WARRANTIES, AND EXPRESSLY DISCLAIMS ALL WARRANTIES, OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE OR USE OR AS TO RESULTS TO BE OBTAINED BY THE COMPANY, OWNERS OF THE PRODUCT, OR ANY OTHER PERSON OR ENTITY FROM THE USE OF THE S&P 500 INDEX OR WITH RESPECT TO ANY DATA RELATED THERETO. WITHOUT LIMITING ANY OF THE FOREGOING, IN NO EVENT WHATSOEVER SHALL S&P DOW JONES INDICES BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES INCLUDING BUT NOT LIMITED TO, LOSS OF PROFITS, TRADING LOSSES, LOST TIME OR GOODWILL, EVEN IF THEY HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, WHETHER IN CONTRACT, TORT, STRICT LIABILITY, OR OTHERWISE. THERE ARE NO THIRD PARTY BENEFICIARIES OF ANY AGREEMENTS OR ARRANGEMENTS BETWEEN S&P DOW JONES INDICES AND THE COMPANY, OTHER THAN THE LICENSORS OF S&P DOW JONES INDICES.”</p>
<p class="text-center mt-6 lg:text-left text-[14px]">
            American Fidelity International Ltd. 
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Terms of Use</u>
            </a>
            |
            <a href="/privacy">
              <u>Privacy Policy</u>
            </a>
            |
            <a href="/secure">
              <u>Secure Computing Practices</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Design by <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9743-1125</p>
        </div>
      </div>`,
  Es: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm ">
          <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Notas de pie de página</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
            La información en este sitio web no representa un contrato de seguro; solo proporciona información general.
          </p> 
          <p class="mb-6 text-justify">
            Seguros de vida a término, universal e indexado: Pueden aplicarse limitaciones y exclusiones.
          </p> 
          <p class="mb-6 text-justify">
            Enfermedades criticas: Pueden aplicarse limitaciones, exclusiones y periodos de carencia.
          </p> 
          <p class="text-justify">El “Índice S&P 500” es un producto de S&P Dow Jones Indices LLC o sus afiliados (“SPDJI”), y ha sido licenciado para usarse por American Fidelity International Ltd. (“La Compañía”). Standard & Poor’s® y S&P® son marcas comerciales registradas de Standard & Poor’s Financial Services LLC (“S&P”) y Dow Jones® es una marca comercial registrada de Dow Jones Trademark Holdings LLC (“Dow Jones”). Las marcas comerciales han sido registradas a SPDJI y han sido sublicenciadas para su uso con ciertos fines por parte de La Compañía. La Póliza de Seguro de Vida Universal Ajustable Indexada con Primas Flexibles (el “Producto”) no está patrocinada, respaldada, vendida ni promocionada por SPDJI, Dow Jones, S&P ni ninguna de sus respectivas afiliadas (colectivamente, “S&P Dow Jones Indices”). S&P Dow Jones Indices, no hace ninguna representación ni garantía, expresa o implícita, a los propietarios del Producto o cualquier miembro del público con respecto a la conveniencia de invertir en títulos en general o en el Producto en particular o la capacidad del Índice S&P 500 para rastrear el desempeño general del mercado. La única relación de S&P Dow Jones Indices con la Compañía con respecto al Índice S&P 500 es la licencia del Índice y ciertas marcas comerciales, marcas de servicio y/o nombres comerciales de S&P Dow Jones Indices y/o sus licenciantes. El Índice S&P 500 está determinado, compuesto y calculado por S&P Dow Jones Indices sin tener en cuenta la Compañía o el Producto. S&P Dow Jones Indices no tiene la obligación de tomar en consideración las necesidades de la Compañía o los propietarios del Producto al determinar, componer o calcular el Índice S&P 500. S&P Dow Jones Indices no es responsable por ni ha participado en la determinación de los precios y el monto del Producto o en el momento de la emisión o venta del Producto o en la determinación o cálculo de la ecuación por la cual el Producto es convertido en efectivo, entregado o redimido, según sea el caso. S&P Dow Jones Indices no tiene ninguna obligación ni responsabilidad en relación con la administración, comercialización o la compraventa del Producto. No hay garantía de que los productos de inversión basados en el S&P 500 hagan un seguimiento preciso del rendimiento del índice o proporcionen rendimientos de inversión positivos. S&P Dow Jones Indices LLC no es un asesor de inversiones. La inclusión de un título dentro de un índice no es una recomendación de S&P Dow Jones Indices para comprar, vender o mantener dicho valor, ni se considera un asesoramiento de inversión.</p>

<p class="mt-4 text-justify">S&P DOW JONES INDICES NO GARANTIZA LA ADECUACIÓN, PRECISIÓN, PUNTUALIDAD Y/O LA INTEGRIDAD DEL ÍNDICE S&P 500 O CUALQUIER DATO RELACIONADO CON ELLO O CUALQUIER COMUNICACIÓN, INCLUYENDO, PERO NO LIMITADO A, COMUNICACIÓN ORAL O ESCRITA (INCLUYENDO LAS COMUNICACIONES ELECTRÓNICAS) CON RESPECTO AL MISMO. S&P DOW JONES INDICES ESTARÁ SUJETO A NINGÚN DAÑO Y PERJUICIO O RESPONSABILIDAD POR CUALQUIER ERROR, OMISIÓN O RETRASO EN EL MISMO. S&P DOW JONES INDICES NO OFRECE GARANTÍAS EXPRESAS O IMPLÍCITAS Y RENUNCIA EXPRESAMENTE A TODAS LAS GARANTÍAS DE COMERCIABILIDAD O APTITUD PARA UN PROPÓSITO O USO EN PARTICULAR O EN CUANTO A LOS RESULTADOS QUE DEBE OBTENER LA COMPAÑÍA, LOS DUEÑOS DEL PRODUCTO, O CUALQUIER OTRA PERSONA O ENTIDAD DEL USO DEL S&P 500 O CON RESPECTO A CUALQUIER DATO RELACIONADO CON ELLO. SIN LIMITAR NADA DE LO ANTERIOR, EN NINGÚN CASO S&P DOW JONES INDICES SERÁ RESPONSABLE DE CUALQUIER DAÑO Y PERJUICIO INDIRECTO, ESPECIAL, INCIDENTAL, PUNITIVO O CONSECUENTE, INCLUYENDO, PERO NO LIMITADO A, PÉRDIDA DE GANANCIAS, PÉRDIDAS COMERCIALES, PÉRDIDA DE TIEMPO O BIENESTAR SI HAN SIDO ADVERTIDOS DE LA POSIBILIDAD DE TALES DAÑOS, YA SEA POR CONTRATO, AGRAVIO, RESPONSABILIDAD ESTRICTA O DE OTRA MANERA. NO HAY TERCEROS BENEFICIARIOS DE NINGÚN ACUERDO O ARREGLO ENTRE S&P DOW JONES INDICES Y LA COMPAÑÍA, EXCEPTO LOS LICENCIADORES DE S&P DOW JONES INDICES.”</p>
<p class="text-center mt-6 lg:text-left text-[14px]">
            American Fidelity International Ltd.
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Términos de Uso</u>
            </a>
            |
            <a href="/privacy">
              <u>Política de Privacidad</u>
            </a>
            |
            <a href="/secure">
              <u>Prácticas de Navegación Seguras</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Diseño de <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9743(Span.)-1125</p>
        </div>
      </div>`,
  Pu: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm ">
          <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Rodapé</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
            As informações deste site não representam um contrato de seguro; fornecem apenas informações gerais. Podem ser aplicadas limitações e exclusões. Doença Crítica: Podem aplicar-se limitações, exclusões e períodos de carência. Este produto não é apropriado para pessoas que sejam elegíveis para cobertura do Medicaid.
          </p> 
          <p class="text-justify">O "Índice S&P 500" é um produto da S&P Dow Jones Indices LLC ou de suas afiliadas ("SPDJI") e foi licenciado para uso pela American Fidelity International Ltd. ("A Companhia"). Standard & Poor's® e S&P® são marcas registradas da Standard & Poor's Financial Services LLC ("S&P") e Dow Jones® é uma marca registrada da Dow Jones Trademark Holdings LLC ("Dow Jones"). As marcas comerciais foram licenciadas para a SPDJI e foram sublicenciadas para uso para determinados fins pela Companhia. A Apólice de Seguro de Vida Universal Ajustável Indexado com Prêmios Flexíveis (o "Produto") não é patrocinada, endossada, vendida ou promovida por SPDJI, Dow Jones, S&P, qualquer de suas respectivas afiliadas (coletivamente, "S&P Dow Jones Indices"). O S&P Dow Jones Indices não fazem nenhuma representação ou garantia, expressa ou implícita, aos proprietários do Produto ou qualquer membro do público em relação à conveniência de investir em títulos em geral ou no Produto em particular ou na capacidade do Índice S&P 500 de acompanhar o desempenho geral do mercado. O único relacionamento entre o S&P Dow Jones Indices e a Companhia com relação ao Índice S&P 500 é o licenciamento do Índice e de certas marcas comerciais, marcas de serviço e/ou nomes comerciais do S&P Dow Jones Indices e/ou de seus licenciados. O Índice S&P 500 é determinado, composto e calculado pelo S&P Dow Jones Indices independentemente da Companhia ou do Produto. S&P Dow Jones Indices não tem obrigação de levar em consideração as necessidades da Companhia ou dos proprietários do Produto ao determinar, compor ou calcular o Índice S&P 500. O S&P Dow Jones Indices não é responsável por e não participou na determinação dos preços e quantidade do Produto ou do tempo de emissão nem da venda do Produto ou na determinação ou cálculo da equação pela qual o Produto deve ser convertido em dinheiro, resgatado ou redimido, conforme seja o caso. S&P Dow Jones Indices não tem nenhuma obrigação ou responsabilidade em relação à administração, marketing ou comercialização do Produto. Não há garantia de que os produtos de investimento baseados no Índice S&P 500 acompanharão com precisão o desempenho do índice ou fornecerão retornos de investimento positivos. S&P Dow Jones Indices LLC não é uma consultora de investimentos. A inclusão de um título dentro de um índice não é uma recomendação da S&P Dow Jones Indices para comprar, vender ou manter tal título, nem é considerada um conselho de investimento.</p>

<p class="mt-4 text-justify">S&P DOW JONES INDICES NÃO GARANTE A ADEQUAÇÃO, PRECISÃO, OPORTUNIDADE E/OU A INTEGRIDADE DO ÍNDICE S&P 500 OU DE QUAISQUER DADOS RELACIONADOS À ELE OU QUALQUER COMUNICAÇÃO, INCLUINDO, MAS NÃO SE LIMITANDO A, COMUNICAÇÃO ORAL OU ESCRITA (INCLUINDO AS COMUNICAÇÕES ELETRÔNICAS) COM RELAÇÃO AOS MESMOS. O S&P DOW JONES INDICES NÃO ESTARÁ SUJEITO A NENHUM DANO E PREJUÍZO OU RESPONSABILIDADE POR QUAISQUER ERROS, OMISSÕES OU ATRASOS NOS MESMOS. S&P DOW JONES INDICES NÃO OFERECE GARANTIAS EXPRESSAS OU IMPLÍCITAS E SE ISENTA EXPRESSAMENTE DE TODAS AS GARANTIAS DE COMERCIABILIDADE OU ADEQUAÇÃO PARA UM DETERMINADO FIM OU USO OU QUANTO A RESULTADOS A SEREM OBTIDOS PELA COMPANHIA, PELOS PROPRIETÁRIOS DO PRODUTO, OU DE QUALQUER OUTRA PESSOA OU ENTIDADE O USO DO ÍNDICE S&P 500 OU COM RELAÇÃO A QUAISQUER DADOS RELACIONADOS COM O MESMO. SEM LIMITAR QUALQUER DOS ACIMA MENCIONADOS, EM NENHUM CASO, A S&P DOW JONES INDICES SERÁ RESPONSÁVEL POR QUAISQUER DANOS OU PREJUÍZOS INDIRETOS, ESPECIAIS, INCIDENTAIS, PUNITIVOS OU CONSEQÜENCIAIS, INCLUINDO, MAS NÃO SE LIMITANDO, A PERDA DE LUCROS, PERDAS DE NEGOCIAÇÃO, PERDAS DE TEMPO OU BENEVOLÊNCIA, SE TIVEREM SIDO AVISADOS DA POSSIBILIDADE DE TAIS DANOS, SEJA EM CONTRATO, DELITO, RESPONSABILIDADE ESTRITA OU DE OUTRA FORMA. NÃO EXISTEM TERCEIROS BENEFICIÁRIOS DE QUAISQUER CONTRATOS OU ARRANJO ENTRE A S&P DOW JONES INDICES E A COMPANHIA, A NÃO SER OS LICENCIANTES DOS S&P DOW JONES INDICES.”</p>
<p class="text-center mt-6 lg:text-left text-[14px]">
            ©2024 American Fidelity International Ltd. - Todos os direitos reservados 
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Termos de Uso</u>
            </a>
            |
            <a href="/privacy">
              <u>Política de Privacidade</u>
            </a>
            |
            <a href="/secure">
              <u>Práticas de Navegação Segura</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Design por <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9743-1125</p>
        </div>
      </div>`,
};

export const footerCodeConstCriticalIllness = {
  Eng: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
  <div class="mt-1 text-[12px] md:text-sm">
    <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Footnotes</u>
              </a>
          </p>
           <p class="mb-6 text-justify">Policy limitations, exclusions, waiting periods and riders may apply.</p>
    <p class="mb-6 text-justify">
      The information in this website does not represent an insurance contract, it only provides general information about the Critical Illness Policy (CI07B.R815). For more information, contact your consultant and refer to the specific conditions of the policy. 
    </p>
    <p class="text-center lg:text-left text-[14px]">
      American Fidelity International Ltd.
    </p>
    <p class="mb-6 text-center lg:text-left">
      
      <a href="/terms">
        <u>Terms of Use</u>
      </a>
      |
      <a href="/privacy">
        <u>Privacy Policy</u>
      </a>
      |
      <a href="/secure">
        <u>Secure Computing Practices</u>
      </a>
    </p>
    <p class="mb-6 text-center lg:text-left text-[14px]">
      Design by <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
      <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
    </p> 
    <p class="mb-4 mt-6 text-center lg:text-left">ESB-9741-1125</p>
  </div>
</div>`,
  Es: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
  <div class="mt-1 text-[12px] md:text-sm">
    <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Notas de pie de página</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
     Pueden aplicarse limitaciones, exclusiones, periodos de carencia y anexos de la póliza.
    </p>
    <p class="mb-6 text-justify">
     La información de este sitio web no representa un contrato de seguro; solo proporciona información general sobre la Póliza de Enfermedades Graves (CI07B.R815). Para obtener más información, comuníquese con su asesor y consulte las condiciones específicas de la póliza.
    </p>
    <p class="text-center lg:text-left text-[14px]">
     American Fidelity International Ltd.
    </p>
    <p class="mb-6 text-center lg:text-left">
      
      <a href="/terms">
        <u>Términos de Uso</u>
      </a>
      |
      <a href="/privacy">
        <u>Política de Privacidad</u>
      </a>
      |
      <a href="/secure">
        <u>Prácticas de Navegación Segura</u>
      </a>
    </p>
    <p class="mb-6 text-center lg:text-left text-[14px]">
      Diseño de <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
      <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
    </p> 
    <p class="mb-4 mt-6 text-center lg:text-left">ESB-9741(Span.)-1125</p>
  </div>
</div>`,
  Pu: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
  <div class="mt-1 text-[12px] md:text-sm">
    <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Rodapé</u>
              </a>
          </p>
    <p class="mb-6 text-justify">
      As informações deste site não representam um contrato de seguro; fornecem apenas informações gerais sobre a Apólice de Doença Crítica (CI07B.R815). Para mais informações, entre em contato com seu consultor e consulte as condições específicas da apólice. Podem ser aplicadas limitações, exclusões, períodos de carência e coberturas adicionais.
    </p>
    <p class="text-center lg:text-left text-[14px]">
      ©2024 American Fidelity International Ltd. - Todos os direitos reservados
    </p>
    <p class="mb-6 text-center lg:text-left">
      
      <a href="/terms">
        <u>Termos de Uso</u>
      </a>
      |
      <a href="/privacy">
        <u>Política de Privacidade</u>
      </a>
      |
      <a href="/secure">
        <u>Práticas de Navegação Segura</u>
      </a>
    </p>
    <p class="mb-6 text-center lg:text-left text-[14px]">
      Design por <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
      <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
    </p> 
    <p class="mb-4 mt-6 text-center lg:text-left">ESB-9741-1224</p>
  </div>
</div>`,
};

export const footerCodeConstSelectTerm = {
  Eng: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
  <div class="mt-1 text-[12px] md:text-sm">
  <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Footnotes</u>
              </a>
          </p>
    <p class="mb-6 text-justify">
      The information in this website does not represent an insurance contract; it only provides general information about the Term Life Insurance Policy (TL04B.R710). For more information, contact your consultant and refer to the specific conditions of the policy. Policy limitations, exclusions and riders may apply.
    </p>
    <p class="text-center lg:text-left text-[14px]">
      American Fidelity International Ltd.
    </p>
    <p class="mb-6 text-center lg:text-left">
      
      <a href="/terms">
        <u>Terms of Use</u>
      </a>
      |
      <a href="/privacy">
        <u>Privacy Policy</u>
      </a>
      |
      <a href="/secure">
        <u>Secure Computing Practices</u>
      </a>
    </p>
    <p class="mb-6 text-center lg:text-left text-[14px]">
      Design by <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
      <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
    </p> 
    <p class="mb-4 mt-6 text-center lg:text-left">ESB-9738-1125</p>
  </div>
</div>`,
  Es: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
  <div class="mt-1 text-[12px] md:text-sm">
  <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Notas de pie de página</u>
              </a>
          </p>
    <p class="mb-6 text-justify">
      La información en este sitio web no representa un contrato de seguro; solo proporciona información general sobre la Póliza de Seguro de Vida a Término (TL04B.R710). Para obtener más información, comuníquese con su asesor y consulte las condiciones específicas de la póliza. Pueden aplicarse limitaciones, exclusiones, períodos de espera y cláusulas adicionales.
    </p>
    <p class="text-center lg:text-left text-[14px]">
      American Fidelity International Ltd. 
    </p>
    <p class="mb-6 text-center lg:text-left">
      
      <a href="/terms">
        <u>Términos de Uso</u>
      </a>
      |
      <a href="/privacy">
        <u>Política de Privacidad</u>
      </a>
      |
      <a href="/secure">
        <u>Prácticas de Navegación Segura</u>
      </a>
    </p>
    <p class="mb-6 text-center lg:text-left text-[14px]">
      Diseño de <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
      <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
    </p> 
    <p class="mb-4 mt-6 text-center lg:text-left">ESB-9738(Span.)-1125</p>
  </div>
</div>`,
  Pu: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
  <div class="mt-1 text-[12px] md:text-sm">
   <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Rodapé</u>
              </a>
          </p>
    <p class="mb-6 text-justify">
      As informações neste site não representam um contrato de seguro; fornecem apenas informações gerais sobre a Apólice de Seguro de Vida Temporário (TL04B.R710). Para mais informações, entre em contato com seu consultor e consulte as condições específicas da apólice. Podem ser aplicadas limitações, exclusões, períodos de carência e coberturas adicionais.
    </p>
    <p class="text-center lg:text-left text-[14px]">
      ©2024 American Fidelity International Ltd. - Todos os direitos reservados
    </p>
    <p class="mb-6 text-center lg:text-left">
      
      <a href="/terms">
        <u>Termos de Uso</u>
      </a>
      |
      <a href="/privacy">
        <u>Política de Privacidade</u>
      </a>
      |
      <a href="/secure">
        <u>Práticas de Navegação Segura</u>
      </a>
    </p>
    <p class="mb-6 text-center lg:text-left text-[14px]">
      Design por <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
      <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
    </p> 
    <p class="mb-4 mt-6 text-center lg:text-left">ESB-9738-1125</p>
  </div>
</div>`,
};

export const footerCodeConstIndexaUniverse = {
  Eng: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm">
          <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Footnotes</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
            Policy limitations, exclusions and riders may apply.
          </p> 
          <p class="mb-4 text-justify">The information in this website does not represent an insurance contract, it only provides general information about the Flexible Premium Adjustable Indexed Universal Life Insurance Policy (FPAIUL20B). For more information, contact your consultant and refer to the specific conditions of the policy.</p> 
          <p class="text-justify">“The"S&P 500 Index"is a product of S&P Dow Jones Indices LLC or its affiliates (“SPDJI”) and has been licensed for use by American Fidelity International Ltd. (the "Company"). Standard & Poor’s® and S&P® are registered trademarks of Standard & Poor’s Financial Services LLC (“S&P”) and Dow Jones® is a registered trademark of Dow Jones Trademark Holdings LLC (“Dow Jones”). The trademarks have been licensed to SPDJI and have been sublicensed for use for certain purposes by the Company. The Flexible Premium Adjustable Indexed Universal Life Insurance Policy (the "Product") is not sponsored, endorsed, sold or promoted by SPDJI, Dow Jones, S&P, any of their respective affiliates (collectively, “S&P Dow Jones Indices”). S&P Dow Jones Indices does not make any representation or warranty, express or implied, to the owners of the Product or any member of the public regarding the advisability of investing in securities generally or in the Product particularly or the ability of the S&P 500 Index to track general market performance. S&P Dow Jones Indices only relationship to the Company with respect to the S&P 500 Index is the licensing of the Index and certain trademarks, service marks and/or trade names of S&P Dow Jones Indices and/or its licensors. The S&P 500 Index is determined, composed and calculated by S&P Dow Jones Indices without regard to the Company or the Product. S&P Dow Jones Indices has no obligation to take the needs of the Company or the owners of the Product into consideration in determining, composing or calculating the S&P 500 Index. S&P Dow Jones Indices is not responsible for and has not participated in the determination of the prices, and amount of the Product or the timing of the issuance or sale of the Product or in the determination or calculation of the equation by which the Product is to be converted into cash, surrendered or redeemed, as the case may be. S&P Dow Jones Indices has no obligation or liability in connection with the administration, marketing or trading of the Product. There is no assurance that investment products based on the S&P 500 Index will accurately track index performance or provide positive investment returns. S&P Dow Jones Indices LLC is not an investment advisor. Inclusion of a security within an index is not a recommendation by S&P Dow Jones Indices to buy, sell, or hold such security, nor is it considered to be investment advice. </p>

<p class="mt-4 text-justify">S&P DOW JONES INDICES DOES NOT GUARANTEE THE ADEQUACY, ACCURACY, TIMELINESS AND/OR THE COMPLETENESS OF THE S&P 500 INDEX OR ANY DATA RELATED THERETO OR ANY COMMUNICATION, INCLUDING BUT NOT LIMITED TO, ORAL OR WRITTEN COMMUNICATION (INCLUDING ELECTRONIC COMMUNICATIONS) WITH RESPECT THERETO. S&P DOW JONES INDICES SHALL NOT BE SUBJECT TO ANY DAMAGES OR LIABILITY FOR ANY ERRORS, OMISSIONS, OR DELAYS THEREIN. S&P DOW JONES INDICES MAKES NO EXPRESS OR IMPLIED WARRANTIES, AND EXPRESSLY DISCLAIMS ALL WARRANTIES, OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE OR USE OR AS TO RESULTS TO BE OBTAINED BY THE COMPANY, OWNERS OF THE PRODUCT, OR ANY OTHER PERSON OR ENTITY FROM THE USE OF THE S&P 500 INDEX OR WITH RESPECT TO ANY DATA RELATED THERETO. WITHOUT LIMITING ANY OF THE FOREGOING, IN NO EVENT WHATSOEVER SHALL S&P DOW JONES INDICES BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES INCLUDING BUT NOT LIMITED TO, LOSS OF PROFITS, TRADING LOSSES, LOST TIME OR GOODWILL, EVEN IF THEY HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, WHETHER IN CONTRACT, TORT, STRICT LIABILITY, OR OTHERWISE. THERE ARE NO THIRD PARTY BENEFICIARIES OF ANY AGREEMENTS OR ARRANGEMENTS BETWEEN S&P DOW JONES INDICES AND THE COMPANY, OTHER THAN THE LICENSORS OF S&P DOW JONES INDICES.”</p>
<p class="text-center mt-6 lg:text-left text-[14px]">
            American Fidelity International Ltd. 
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Terms of Use</u>
            </a>
            |
            <a href="/privacy">
              <u>Privacy Policy</u>
            </a>
            |
            <a href="/secure">
              <u>Secure Computing Practices</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Design by <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9740-1125</p>
        </div>
      </div>`,
  Es: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm">
          <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Notas de pie de página</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
            Pueden aplicarse limitaciones, exclusiones y anexos de la póliza.
          </p> 
          <p class="mb-4 text-justify">La información en este sitio web no representa un contrato de seguro; solo proporciona información general sobre la Póliza de Seguro de Vida Universal Indexada con Prima Flexible Ajustable (FPAIUL20B). Para obtener más información, comuníquese con su consultor y consulte las condiciones específicas de la póliza.</p> 
          <p class="text-justify">El “Índice S&P 500” es un producto de S&P Dow Jones Indices LLC o sus afiliados (“SPDJI”), y ha sido licenciado para usarse por American Fidelity International Ltd. (“La Compañía”). Standard & Poor’s® y S&P® son marcas comerciales registradas de Standard & Poor’s Financial Services LLC (“S&P”) y Dow Jones® es una marca comercial registrada de Dow Jones Trademark Holdings LLC (“Dow Jones”). Las marcas comerciales han sido registradas a SPDJI y han sido sublicenciadas para su uso con ciertos fines por parte de La Compañía. La Póliza de Seguro de Vida Universal Ajustable Indexada con Primas Flexibles (el “Producto”) no está patrocinada, respaldada, vendida ni promocionada por SPDJI, Dow Jones, S&P ni ninguna de sus respectivas afiliadas (colectivamente, “S&P Dow Jones Indices”). S&P Dow Jones Indices, no hace ninguna representación ni garantía, expresa o implícita, a los propietarios del Producto o cualquier miembro del público con respecto a la conveniencia de invertir en títulos en general o en el Producto en particular o la capacidad del Índice S&P 500 para rastrear el desempeño general del mercado. La única relación de S&P Dow Jones Indices con la Compañía con respecto al Índice S&P 500 es la licencia del Índice y ciertas marcas comerciales, marcas de servicio y/o nombres comerciales de S&P Dow Jones Indices y/o sus licenciantes. El Índice S&P 500 está determinado, compuesto y calculado por S&P Dow Jones Indices sin tener en cuenta la Compañía o el Producto. S&P Dow Jones Indices no tiene la obligación de tomar en consideración las necesidades de la Compañía o los propietarios del Producto al determinar, componer o calcular el Índice S&P 500. S&P Dow Jones Indices no es responsable por ni ha participado en la determinación de los precios y el monto del Producto o en el momento de la emisión o venta del Producto o en la determinación o cálculo de la ecuación por la cual el Producto es convertido en efectivo, entregado o redimido, según sea el caso. S&P Dow Jones Indices no tiene ninguna obligación ni responsabilidad en relación con la administración, comercialización o la compraventa del Producto. No hay garantía de que los productos de inversión basados en el S&P 500 hagan un seguimiento preciso del rendimiento del índice o proporcionen rendimientos de inversión positivos. S&P Dow Jones Indices LLC no es un asesor de inversiones. La inclusión de un título dentro de un índice no es una recomendación de S&P Dow Jones Indices para comprar, vender o mantener dicho valor, ni se considera un asesoramiento de inversión.</p>

<p class="mt-4 text-justify">S&P DOW JONES INDICES NO GARANTIZA LA ADECUACIÓN, PRECISIÓN, PUNTUALIDAD Y/O LA INTEGRIDAD DEL ÍNDICE S&P 500 O CUALQUIER DATO RELACIONADO CON ELLO O CUALQUIER COMUNICACIÓN, INCLUYENDO, PERO NO LIMITADO A, COMUNICACIÓN ORAL O ESCRITA (INCLUYENDO LAS COMUNICACIONES ELECTRÓNICAS) CON RESPECTO AL MISMO. S&P DOW JONES INDICES ESTARÁ SUJETO A NINGÚN DAÑO Y PERJUICIO O RESPONSABILIDAD POR CUALQUIER ERROR, OMISIÓN O RETRASO EN EL MISMO. S&P DOW JONES INDICES NO OFRECE GARANTÍAS EXPRESAS O IMPLÍCITAS Y RENUNCIA EXPRESAMENTE A TODAS LAS GARANTÍAS DE COMERCIABILIDAD O APTITUD PARA UN PROPÓSITO O USO EN PARTICULAR O EN CUANTO A LOS RESULTADOS QUE DEBE OBTENER LA COMPAÑÍA, LOS DUEÑOS DEL PRODUCTO, O CUALQUIER OTRA PERSONA O ENTIDAD DEL USO DEL S&P 500 O CON RESPECTO A CUALQUIER DATO RELACIONADO CON ELLO. SIN LIMITAR NADA DE LO ANTERIOR, EN NINGÚN CASO S&P DOW JONES INDICES SERÁ RESPONSABLE DE CUALQUIER DAÑO Y PERJUICIO INDIRECTO, ESPECIAL, INCIDENTAL, PUNITIVO O CONSECUENTE, INCLUYENDO, PERO NO LIMITADO A, PÉRDIDA DE GANANCIAS, PÉRDIDAS COMERCIALES, PÉRDIDA DE TIEMPO O BIENESTAR SI HAN SIDO ADVERTIDOS DE LA POSIBILIDAD DE TALES DAÑOS, YA SEA POR CONTRATO, AGRAVIO, RESPONSABILIDAD ESTRICTA O DE OTRA MANERA. NO HAY TERCEROS BENEFICIARIOS DE NINGÚN ACUERDO O ARREGLO ENTRE S&P DOW JONES INDICES Y LA COMPAÑÍA, EXCEPTO LOS LICENCIADORES DE S&P DOW JONES INDICES.”</p>
<p class="text-center mt-6 lg:text-left text-[14px]">
            American Fidelity International Ltd. 
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Términos de Uso</u>
            </a>
            |
            <a href="/privacy">
              <u>Política de Privacidad</u>
            </a>
            |
            <a href="/secure">
              <u>Prácticas de Navegación Segura</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Diseño de <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9740(Span.)-1125</p>
        </div>
      </div>`,
  Pu: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm">
          <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Rodapé</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
            Podem aplicar-se limitações, exclusões e adicionais da apólice.
          </p> 
          <p class="mb-4 text-justify">As informações neste site não representam um contrato de seguro; fornecem apenas informações gerais sobre a Apólice de Seguro de Vida Universal Indexado com Prêmio Flexível Ajustável (FPAIUL20B). Para mais informações, entre em contato com seu consultor e consulte as condições específicas da apólice.</p> 
          <p class="text-justify">O "Índice S&P 500" é um produto da S&P Dow Jones Indices LLC ou de suas afiliadas ("SPDJI") e foi licenciado para uso pela American Fidelity International Ltd. ("A Companhia"). Standard & Poor's® e S&P® são marcas registradas da Standard & Poor's Financial Services LLC ("S&P") e Dow Jones® é uma marca registrada da Dow Jones Trademark Holdings LLC ("Dow Jones"). As marcas comerciais foram licenciadas para a SPDJI e foram sublicenciadas para uso para determinados fins pela Companhia. A Apólice de Seguro de Vida Universal Ajustável Indexado com Prêmios Flexíveis (o "Produto") não é patrocinada, endossada, vendida ou promovida por SPDJI, Dow Jones, S&P, qualquer de suas respectivas afiliadas (coletivamente, "S&P Dow Jones Indices"). O S&P Dow Jones Indices não fazem nenhuma representação ou garantia, expressa ou implícita, aos proprietários do Produto ou qualquer membro do público em relação à conveniência de investir em títulos em geral ou no Produto em particular ou na capacidade do Índice S&P 500 de acompanhar o desempenho geral do mercado. O único relacionamento entre o S&P Dow Jones Indices e a Companhia com relação ao Índice S&P 500 é o licenciamento do Índice e de certas marcas comerciais, marcas de serviço e/ou nomes comerciais do S&P Dow Jones Indices e/ou de seus licenciados. O Índice S&P 500 é determinado, composto e calculado pelo S&P Dow Jones Indices independentemente da Companhia ou do Produto. S&P Dow Jones Indices não tem obrigação de levar em consideração as necessidades da Companhia ou dos proprietários do Produto ao determinar, compor ou calcular o Índice S&P 500. O S&P Dow Jones Indices não é responsável por e não participou na determinação dos preços e quantidade do Produto ou do tempo de emissão nem da venda do Produto ou na determinação ou cálculo da equação pela qual o Produto deve ser convertido em dinheiro, resgatado ou redimido, conforme seja o caso. S&P Dow Jones Indices não tem nenhuma obrigação ou responsabilidade em relação à administração, marketing ou comercialização do Produto. Não há garantia de que os produtos de investimento baseados no Índice S&P 500 acompanharão com precisão o desempenho do índice ou fornecerão retornos de investimento positivos. S&P Dow Jones Indices LLC não é uma consultora de investimentos. A inclusão de um título dentro de um índice não é uma recomendação da S&P Dow Jones Indices para comprar, vender ou manter tal título, nem é considerada um conselho de investimento.</p>

<p class="mt-4 text-justify">S&P DOW JONES INDICES NÃO GARANTE A ADEQUAÇÃO, PRECISÃO, OPORTUNIDADE E/OU A INTEGRIDADE DO ÍNDICE S&P 500 OU DE QUAISQUER DADOS RELACIONADOS À ELE OU QUALQUER COMUNICAÇÃO, INCLUINDO, MAS NÃO SE LIMITANDO A, COMUNICAÇÃO ORAL OU ESCRITA (INCLUINDO AS COMUNICAÇÕES ELETRÔNICAS) COM RELAÇÃO AOS MESMOS. O S&P DOW JONES INDICES NÃO ESTARÁ SUJEITO A NENHUM DANO E PREJUÍZO OU RESPONSABILIDADE POR QUAISQUER ERROS, OMISSÕES OU ATRASOS NOS MESMOS. S&P DOW JONES INDICES NÃO OFERECE GARANTIAS EXPRESSAS OU IMPLÍCITAS E SE ISENTA EXPRESSAMENTE DE TODAS AS GARANTIAS DE COMERCIABILIDADE OU ADEQUAÇÃO PARA UM DETERMINADO FIM OU USO OU QUANTO A RESULTADOS A SEREM OBTIDOS PELA COMPANHIA, PELOS PROPRIETÁRIOS DO PRODUTO, OU DE QUALQUER OUTRA PESSOA OU ENTIDADE O USO DO ÍNDICE S&P 500 OU COM RELAÇÃO A QUAISQUER DADOS RELACIONADOS COM O MESMO. SEM LIMITAR QUALQUER DOS ACIMA MENCIONADOS, EM NENHUM CASO, A S&P DOW JONES INDICES SERÁ RESPONSÁVEL POR QUAISQUER DANOS OU PREJUÍZOS INDIRETOS, ESPECIAIS, INCIDENTAIS, PUNITIVOS OU CONSEQÜENCIAIS, INCLUINDO, MAS NÃO SE LIMITANDO, A PERDA DE LUCROS, PERDAS DE NEGOCIAÇÃO, PERDAS DE TEMPO OU BENEVOLÊNCIA, SE TIVEREM SIDO AVISADOS DA POSSIBILIDADE DE TAIS DANOS, SEJA EM CONTRATO, DELITO, RESPONSABILIDADE ESTRITA OU DE OUTRA FORMA. NÃO EXISTEM TERCEIROS BENEFICIÁRIOS DE QUAISQUER CONTRATOS OU ARRANJO ENTRE A S&P DOW JONES INDICES E A COMPANHIA, A NÃO SER OS LICENCIANTES DOS S&P DOW JONES INDICES.”</p>
<p class="text-center mt-6 lg:text-left text-[14px]">
            ©2024 American Fidelity International Ltd. - Todos os direitos reservados
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Termos de Uso</u>
            </a>
            |
            <a href="/privacy">
              <u>Política de Privacidade</u>
            </a>
            |
            <a href="/secure">
              <u>Práticas de Navegação Segura</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Design por <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9740-1125</p>
        </div>
      </div>`,
};

export const footerCodeConstUniverseLife = {
  Eng: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Footnotes</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
            The information in this website does not represent an insurance contract, it only provides general information.
          </p> 
          <p class="mb-6 text-justify">
            Life (Term, Universal Life and Indexed Universal Life): Limitations and exclusions may apply.
          </p> 
          <p class="text-justify">“The"S&P 500 Index"is a product of S&P Dow Jones Indices LLC or its affiliates (“SPDJI”) and has been licensed for use by American Fidelity International Ltd. (the "Company"). Standard & Poor’s® and S&P® are registered trademarks of Standard & Poor’s Financial Services LLC (“S&P”) and Dow Jones® is a registered trademark of Dow Jones Trademark Holdings LLC (“Dow Jones”). The trademarks have been licensed to SPDJI and have been sublicensed for use for certain purposes by the Company. The Flexible Premium Adjustable Indexed Universal Life Insurance Policy (the "Product") is not sponsored, endorsed, sold or promoted by SPDJI, Dow Jones, S&P, any of their respective affiliates (collectively, “S&P Dow Jones Indices”). S&P Dow Jones Indices does not make any representation or warranty, express or implied, to the owners of the Product or any member of the public regarding the advisability of investing in securities generally or in the Product particularly or the ability of the S&P 500 Index to track general market performance. S&P Dow Jones Indices only relationship to the Company with respect to the S&P 500 Index is the licensing of the Index and certain trademarks, service marks and/or trade names of S&P Dow Jones Indices and/or its licensors. The S&P 500 Index is determined, composed and calculated by S&P Dow Jones Indices without regard to the Company or the Product. S&P Dow Jones Indices has no obligation to take the needs of the Company or the owners of the Product into consideration in determining, composing or calculating the S&P 500 Index. S&P Dow Jones Indices is not responsible for and has not participated in the determination of the prices, and amount of the Product or the timing of the issuance or sale of the Product or in the determination or calculation of the equation by which the Product is to be converted into cash, surrendered or redeemed, as the case may be. S&P Dow Jones Indices has no obligation or liability in connection with the administration, marketing or trading of the Product. There is no assurance that investment products based on the S&P 500 Index will accurately track index performance or provide positive investment returns. S&P Dow Jones Indices LLC is not an investment advisor. Inclusion of a security within an index is not a recommendation by S&P Dow Jones Indices to buy, sell, or hold such security, nor is it considered to be investment advice.  </p>

<p class="mt-4 text-justify">S&P DOW JONES INDICES DOES NOT GUARANTEE THE ADEQUACY, ACCURACY, TIMELINESS AND/OR THE COMPLETENESS OF THE S&P 500 INDEX OR ANY DATA RELATED THERETO OR ANY COMMUNICATION, INCLUDING BUT NOT LIMITED TO, ORAL OR WRITTEN COMMUNICATION (INCLUDING ELECTRONIC COMMUNICATIONS) WITH RESPECT THERETO. S&P DOW JONES INDICES SHALL NOT BE SUBJECT TO ANY DAMAGES OR LIABILITY FOR ANY ERRORS, OMISSIONS, OR DELAYS THEREIN. S&P DOW JONES INDICES MAKES NO EXPRESS OR IMPLIED WARRANTIES, AND EXPRESSLY DISCLAIMS ALL WARRANTIES, OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE OR USE OR AS TO RESULTS TO BE OBTAINED BY THE COMPANY, OWNERS OF THE PRODUCT, OR ANY OTHER PERSON OR ENTITY FROM THE USE OF THE S&P 500 INDEX OR WITH RESPECT TO ANY DATA RELATED THERETO. WITHOUT LIMITING ANY OF THE FOREGOING, IN NO EVENT WHATSOEVER SHALL S&P DOW JONES INDICES BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES INCLUDING BUT NOT LIMITED TO, LOSS OF PROFITS, TRADING LOSSES, LOST TIME OR GOODWILL, EVEN IF THEY HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, WHETHER IN CONTRACT, TORT, STRICT LIABILITY, OR OTHERWISE. THERE ARE NO THIRD PARTY BENEFICIARIES OF ANY AGREEMENTS OR ARRANGEMENTS BETWEEN S&P DOW JONES INDICES AND THE COMPANY, OTHER THAN THE LICENSORS OF S&P DOW JONES INDICES.”</p>
<p class="text-center mt-6 lg:text-left text-[14px]">
            American Fidelity International Ltd.
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Terms of Use</u>
            </a>
            |
            <a href="/privacy">
              <u>Privacy Policy</u>
            </a>
            |
            <a href="/secure">
              <u>Secure Computing Practices</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Design by <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9739-1125</p>
        </div>
      </div>`,
  Es: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Notas de pie de página</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
            La información en este sitio web no representa un contrato de seguro; solo proporciona información general.
          </p> 
          <p class="mb-6 text-justify">
            Vida (a término, universal e indexado): Pueden aplicarse limitaciones y exclusiones.
          </p> 
          <p class="mb-4 text-justify">La información en este sitio web no representa un contrato de seguro; solo proporciona información general sobre las pólizas Ultra III (Póliza de Seguro de Vida con Prima Flexible y Ajustable, FPAL132B), Prime (Póliza de Seguro de Vida con Prima Flexible y Ajustable, FPAL17B) y Indexa Pro IUL (Póliza de Seguro de Vida Universal Indexada con Prima Flexible y Ajustable, FPAIUL20B). Para obtener más información, comuníquese con su asesor y consulte las condiciones específicas de la póliza.</p> 
          <p class="text-justify">El “Índice S&P 500” es un producto de S&P Dow Jones Indices LLC o sus afiliados (“SPDJI”), y ha sido licenciado para usarse por American Fidelity International Ltd. (“La Compañía”). Standard & Poor’s® y S&P® son marcas comerciales registradas de Standard & Poor’s Financial Services LLC (“S&P”) y Dow Jones® es una marca comercial registrada de Dow Jones Trademark Holdings LLC (“Dow Jones”). Las marcas comerciales han sido registradas a SPDJI y han sido sublicenciadas para su uso con ciertos fines por parte de La Compañía. La Póliza de Seguro de Vida Universal Ajustable Indexada con Primas Flexibles (el “Producto”) no está patrocinada, respaldada, vendida ni promocionada por SPDJI, Dow Jones, S&P ni ninguna de sus respectivas afiliadas (colectivamente, “S&P Dow Jones Indices”). S&P Dow Jones Indices, no hace ninguna representación ni garantía, expresa o implícita, a los propietarios del Producto o cualquier miembro del público con respecto a la conveniencia de invertir en títulos en general o en el Producto en particular o la capacidad del Índice S&P 500 para rastrear el desempeño general del mercado. La única relación de S&P Dow Jones Indices con la Compañía con respecto al Índice S&P 500 es la licencia del Índice y ciertas marcas comerciales, marcas de servicio y/o nombres comerciales de S&P Dow Jones Indices y/o sus licenciantes. El Índice S&P 500 está determinado, compuesto y calculado por S&P Dow Jones Indices sin tener en cuenta la Compañía o el Producto. S&P Dow Jones Indices no tiene la obligación de tomar en consideración las necesidades de la Compañía o los propietarios del Producto al determinar, componer o calcular el Índice S&P 500. S&P Dow Jones Indices no es responsable por ni ha participado en la determinación de los precios y el monto del Producto o en el momento de la emisión o venta del Producto o en la determinación o cálculo de la ecuación por la cual el Producto es convertido en efectivo, entregado o redimido, según sea el caso. S&P Dow Jones Indices no tiene ninguna obligación ni responsabilidad en relación con la administración, comercialización o la compraventa del Producto. No hay garantía de que los productos de inversión basados en el S&P 500 hagan un seguimiento preciso del rendimiento del índice o proporcionen rendimientos de inversión positivos. S&P Dow Jones Indices LLC no es un asesor de inversiones. La inclusión de un título dentro de un índice no es una recomendación de S&P Dow Jones Indices para comprar, vender o mantener dicho valor, ni se considera un asesoramiento de inversión.</p>

<p class="mt-4 text-justify">S&P DOW JONES INDICES NO GARANTIZA LA ADECUACIÓN, PRECISIÓN, PUNTUALIDAD Y/O LA INTEGRIDAD DEL ÍNDICE S&P 500 O CUALQUIER DATO RELACIONADO CON ELLO O CUALQUIER COMUNICACIÓN, INCLUYENDO, PERO NO LIMITADO A, COMUNICACIÓN ORAL O ESCRITA (INCLUYENDO LAS COMUNICACIONES ELECTRÓNICAS) CON RESPECTO AL MISMO. S&P DOW JONES INDICES ESTARÁ SUJETO A NINGÚN DAÑO Y PERJUICIO O RESPONSABILIDAD POR CUALQUIER ERROR, OMISIÓN O RETRASO EN EL MISMO. S&P DOW JONES INDICES NO OFRECE GARANTÍAS EXPRESAS O IMPLÍCITAS Y RENUNCIA EXPRESAMENTE A TODAS LAS GARANTÍAS DE COMERCIABILIDAD O APTITUD PARA UN PROPÓSITO O USO EN PARTICULAR O EN CUANTO A LOS RESULTADOS QUE DEBE OBTENER LA COMPAÑÍA, LOS DUEÑOS DEL PRODUCTO, O CUALQUIER OTRA PERSONA O ENTIDAD DEL USO DEL S&P 500 O CON RESPECTO A CUALQUIER DATO RELACIONADO CON ELLO. SIN LIMITAR NADA DE LO ANTERIOR, EN NINGÚN CASO S&P DOW JONES INDICES SERÁ RESPONSABLE DE CUALQUIER DAÑO Y PERJUICIO INDIRECTO, ESPECIAL, INCIDENTAL, PUNITIVO O CONSECUENTE, INCLUYENDO, PERO NO LIMITADO A, PÉRDIDA DE GANANCIAS, PÉRDIDAS COMERCIALES, PÉRDIDA DE TIEMPO O BIENESTAR SI HAN SIDO ADVERTIDOS DE LA POSIBILIDAD DE TALES DAÑOS, YA SEA POR CONTRATO, AGRAVIO, RESPONSABILIDAD ESTRICTA O DE OTRA MANERA. NO HAY TERCEROS BENEFICIARIOS DE NINGÚN ACUERDO O ARREGLO ENTRE S&P DOW JONES INDICES Y LA COMPAÑÍA, EXCEPTO LOS LICENCIADORES DE S&P DOW JONES INDICES.”</p>
<p class="text-center mt-6 lg:text-left text-[14px]">
           American Fidelity International Ltd. 
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Términos de Uso</u>
            </a>
            |
            <a href="/privacy">
              <u>Política de Privacidad</u>
            </a>
            |
            <a href="/secure">
              <u>Prácticas de Navegación Segura</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Diseño de <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9739(Span.)-1125</p>
        </div>
      </div>`,
  Pu: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
        <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6 text-center lg:text-left">
            <a href="/footnotes">
                <u>Rodapé</u>
              </a>
          </p>
          <p class="mb-6 text-justify">
            As informações neste site não representam um contrato de seguro; fornecem apenas informações gerais sobre a Apólice de Seguro de Vida Temporário (TL04B.R710). Para mais informações, entre em contato com seu consultor e consulte as condições específicas da apólice. Podem ser aplicadas limitações, exclusões, períodos de carência e coberturas adicionais.
          </p> 
          <p class="mb-6 text-justify">
            Podem ser aplicadas limitações e exclusões.
          </p> 
          <p class="mb-4 text-justify">As informações neste site não representam um contrato de seguro; fornecem apenas informações gerais sobre as apólices Ultra III (Apólice de Seguro de Vida com Prêmio Flexível e Ajustável, FPAL132B), Prime (Apólice de Seguro de Vida com Prêmio Flexível e Ajustável, FPAL17B) e Indexa Pro IUL (Apólice de Seguro de Vida Universal Indexada com Prêmio Flexível e Ajustável, FPAIUL20B). Para mais informações, entre em contato com seu consultor e consulte as condições específicas da apólice.</p> 
          <p class="text-justify">O "Índice S&P 500" é um produto da S&P Dow Jones Indices LLC ou de suas afiliadas ("SPDJI") e foi licenciado para uso pela American Fidelity International Ltd. ("A Companhia"). Standard & Poor's® e S&P® são marcas registradas da Standard & Poor's Financial Services LLC ("S&P") e Dow Jones® é uma marca registrada da Dow Jones Trademark Holdings LLC ("Dow Jones"). As marcas comerciais foram licenciadas para a SPDJI e foram sublicenciadas para uso para determinados fins pela Companhia. A Apólice de Seguro de Vida Universal Ajustável Indexado com Prêmios Flexíveis (o "Produto") não é patrocinada, endossada, vendida ou promovida por SPDJI, Dow Jones, S&P, qualquer de suas respectivas afiliadas (coletivamente, "S&P Dow Jones Indices"). O S&P Dow Jones Indices não fazem nenhuma representação ou garantia, expressa ou implícita, aos proprietários do Produto ou qualquer membro do público em relação à conveniência de investir em títulos em geral ou no Produto em particular ou na capacidade do Índice S&P 500 de acompanhar o desempenho geral do mercado. O único relacionamento entre o S&P Dow Jones Indices e a Companhia com relação ao Índice S&P 500 é o licenciamento do Índice e de certas marcas comerciais, marcas de serviço e/ou nomes comerciais do S&P Dow Jones Indices e/ou de seus licenciados. O Índice S&P 500 é determinado, composto e calculado pelo S&P Dow Jones Indices independentemente da Companhia ou do Produto. S&P Dow Jones Indices não tem obrigação de levar em consideração as necessidades da Companhia ou dos proprietários do Produto ao determinar, compor ou calcular o Índice S&P 500. O S&P Dow Jones Indices não é responsável por e não participou na determinação dos preços e quantidade do Produto ou do tempo de emissão nem da venda do Produto ou na determinação ou cálculo da equação pela qual o Produto deve ser convertido em dinheiro, resgatado ou redimido, conforme seja o caso. S&P Dow Jones Indices não tem nenhuma obrigação ou responsabilidade em relação à administração, marketing ou comercialização do Produto. Não há garantia de que os produtos de investimento baseados no Índice S&P 500 acompanharão com precisão o desempenho do índice ou fornecerão retornos de investimento positivos. S&P Dow Jones Indices LLC não é uma consultora de investimentos. A inclusão de um título dentro de um índice não é uma recomendação da S&P Dow Jones Indices para comprar, vender ou manter tal título, nem é considerada um conselho de investimento.</p>

<p class="mt-4 text-justify">S&P DOW JONES INDICES NÃO GARANTE A ADEQUAÇÃO, PRECISÃO, OPORTUNIDADE E/OU A INTEGRIDADE DO ÍNDICE S&P 500 OU DE QUAISQUER DADOS RELACIONADOS À ELE OU QUALQUER COMUNICAÇÃO, INCLUINDO, MAS NÃO SE LIMITANDO A, COMUNICAÇÃO ORAL OU ESCRITA (INCLUINDO AS COMUNICAÇÕES ELETRÔNICAS) COM RELAÇÃO AOS MESMOS. O S&P DOW JONES INDICES NÃO ESTARÁ SUJEITO A NENHUM DANO E PREJUÍZO OU RESPONSABILIDADE POR QUAISQUER ERROS, OMISSÕES OU ATRASOS NOS MESMOS. S&P DOW JONES INDICES NÃO OFERECE GARANTIAS EXPRESSAS OU IMPLÍCITAS E SE ISENTA EXPRESSAMENTE DE TODAS AS GARANTIAS DE COMERCIABILIDADE OU ADEQUAÇÃO PARA UM DETERMINADO FIM OU USO OU QUANTO A RESULTADOS A SEREM OBTIDOS PELA COMPANHIA, PELOS PROPRIETÁRIOS DO PRODUTO, OU DE QUALQUER OUTRA PESSOA OU ENTIDADE O USO DO ÍNDICE S&P 500 OU COM RELAÇÃO A QUAISQUER DADOS RELACIONADOS COM O MESMO. SEM LIMITAR QUALQUER DOS ACIMA MENCIONADOS, EM NENHUM CASO, A S&P DOW JONES INDICES SERÁ RESPONSÁVEL POR QUAISQUER DANOS OU PREJUÍZOS INDIRETOS, ESPECIAIS, INCIDENTAIS, PUNITIVOS OU CONSEQÜENCIAIS, INCLUINDO, MAS NÃO SE LIMITANDO, A PERDA DE LUCROS, PERDAS DE NEGOCIAÇÃO, PERDAS DE TEMPO OU BENEVOLÊNCIA, SE TIVEREM SIDO AVISADOS DA POSSIBILIDADE DE TAIS DANOS, SEJA EM CONTRATO, DELITO, RESPONSABILIDADE ESTRITA OU DE OUTRA FORMA. NÃO EXISTEM TERCEIROS BENEFICIÁRIOS DE QUAISQUER CONTRATOS OU ARRANJO ENTRE A S&P DOW JONES INDICES E A COMPANHIA, A NÃO SER OS LICENCIANTES DOS S&P DOW JONES INDICES.”</p>
<p class="text-center mt-6 lg:text-left text-[14px]">
            ©2024 American Fidelity International Ltd. - Todos os direitos reservados
          </p>
          <p class="mb-6 text-center lg:text-left">
           
            <a href="/terms">
              <u>Termos de Uso</u>
            </a>
            |
            <a href="/privacy">
              <u>Política de Privacidade</u>
            </a>
            |
            <a href="/secure">
              <u>Práticas de Navegação Segura</u>
            </a>
          </p>
          <p class="mb-6 text-center lg:text-left text-[14px]">
            Design por <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
            <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
          </p> 
          <p class="mb-4 mt-6 text-center lg:text-left">ESB-9741-1125</p>
        </div>
      </div>`,
};

export const footerCodeConstCreditedInterestRate = {
  Eng: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">         
        <p class="text-center lg:text-left text-[14px]">
          ESB-650-1125
        </p>  
      </div>
    </div>`,
  Es: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">         
        <p class="text-center lg:text-left text-[14px]">
          ESB-650(Span.)-1125
        </p>  
      </div>
    </div>`,

  Pu: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">
        <p class="text-center lg:text-left text-[14px]">
          ESB-650-0320
        </p>   
      </div>
    </div>`,
};

export const footerCodeConstTerms = {
  Eng: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6 text-justify">
          Products described on this website are available only to residents outside of the United States where rates are available (restrictions may apply in some countries). These plans are underwritten by American Fidelity International, Ltd. (AFIL).
        </p>
        <p class="mb-6 text-justify">
          This website only providers general information about AFIL products. Policy limitations, exclusions, deductibles, and waiting periods may apply.
        </p>
        <p class="text-center lg:text-left text-[14px]">
          American Fidelity International Ltd.
        </p>
        <p class="mb-6 text-center lg:text-left">
         
          <a href="/terms">
            <u>Terms of Use</u>
          </a>
          |
          <a href="/privacy">
            <u>Privacy Policy</u>
          </a>
          |
          <a href="/secure">
            <u>Secure Computing Practices</u>
          </a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">
          Design by <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
          <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
        </p>  
        <p class="mb-6 text-center lg:text-left text-[14px]">M-3891-1125</p>
      </div> 
    </div>`,
  Es: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6 text-justify">
          Pueden aplicarse limitaciones, exclusiones y períodos de espera.
        </p>
        <p class="mb-6 text-justify">
          La información de este sitio web no representa un contrato de seguro, solo proporciona información general sobre la Ultra III (Póliza de Seguro de Vida Ajustable de Prima Flexible, FPAL132B), Prime (Póliza de Seguro de Vida Ajustable de Prima Flexible, FPAL17B) y el Index Pro IUL (Póliza de Seguro de Vida Universal Indexada de Prima Flexible Ajustable, FPAIUL20B). Para obtener más información, póngase en contacto con su asesor y consulte las condiciones específicas de la póliza. Es posible que se apliquen limitaciones, exclusiones, períodos de espera y cláusulas adicionales.
        </p>
        <p class="text-center lg:text-left text-[14px]">
          American Fidelity International Ltd. 
        </p>
        <p class="mb-6 text-center lg:text-left">
         
          <a href="/terms">
            <u>Términos de Uso</u>
          </a>
          |
          <a href="/privacy">
            <u>Política de Privacidad</u>
          </a>
          |
          <a href="/secure">
            <u>Prácticas de Navegación Segura</u>
          </a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">
          Diseño de <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
          <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">M-3891(Span.)-1125</p>  
      </div>
    </div>`,
  Pu: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6">
          Limitações, exclusões e períodos de espera podem ser aplicados.
        </p>
        <p class="mb-6 text-justify">
          As informações contidas neste site não representam um contrato de seguro, apenas fornecem informações gerais sobre o Ultra III (Apólice de Seguro de Vida Ajustável de Prêmio Flexível, FPAL132B), Prime (Apólice de Seguro de Vida Ajustável de Prêmio Flexível, FPAL17B) e o Index Pro IUL (Apólice de Seguro de Vida Universal Indexada de Prêmio Flexível Ajustável, FPAIUL20B). Para mais informações, contacte o seu consultor e consulte as condições específicas da apólice. Limitações da apólice, exclusões e períodos de espera e cláusulas adicionais podem ser aplicados.
        </p>
        <p class="text-center lg:text-left text-[14px]">
          ©2024 American Fidelity International Ltd. - Todos os direitos reservados
        </p>
        <p class="mb-6 text-center lg:text-left">
         
          <a href="/terms">
            <u>Termos de Uso</u>
          </a>
          |
          <a href="/privacy">
            <u>Política de Privacidade</u>
          </a>
          |
          <a href="/secure">
            <u>Práticas de Navegação Segura</u>
          </a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">
          Design por <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
          <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
        </p>  
        <p class="mb-6 text-center lg:text-left text-[14px]">M-3891-1125</p>
      </div>
    </div>`,
};

export const footerCodeConstPrivacy = {
  Eng: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6 text-justify">
          Products described on this website are available only to residents outside of the United States where rates are available (restrictions may apply in some countries). These plans are underwritten by American Fidelity International, Ltd. (AFIL).
        </p>
        <p class="mb-6 text-justify">
          This website only providers general information about AFIL products. Policy limitations, exclusions, deductibles, and waiting periods may apply.
        </p>
        <p class="text-center lg:text-left text-[14px]">
          American Fidelity International Ltd.
        </p>
        <p class="mb-6 text-center lg:text-left">
         
          <a href="/terms">
            <u>Terms of Use</u>
          </a>
          |
          <a href="/privacy">
            <u>Privacy Policy</u>
          </a>
          |
          <a href="/secure">
            <u>Secure Computing Practices</u>
          </a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">
          Design by <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
          <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
        </p>  
        <p class="mb-6 text-center lg:text-left text-[14px]">M-3892-1125</p>
      </div> 
    </div>`,
  Es: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6 text-justify">
          Pueden aplicarse limitaciones, exclusiones y períodos de espera.
        </p>
        <p class="mb-6 text-justify">
          La información de este sitio web no representa un contrato de seguro, solo proporciona información general sobre la Ultra III (Póliza de Seguro de Vida Ajustable de Prima Flexible, FPAL132B), Prime (Póliza de Seguro de Vida Ajustable de Prima Flexible, FPAL17B) y el Index Pro IUL (Póliza de Seguro de Vida Universal Indexada de Prima Flexible Ajustable, FPAIUL20B). Para obtener más información, póngase en contacto con su asesor y consulte las condiciones específicas de la póliza. Es posible que se apliquen limitaciones, exclusiones, períodos de espera y cláusulas adicionales.
        </p>
        <p class="text-center lg:text-left text-[14px]">
          American Fidelity International Ltd. 
        </p>
        <p class="mb-6 text-center lg:text-left">
         
          <a href="/terms">
            <u>Términos de Uso</u>
          </a>
          |
          <a href="/privacy">
            <u>Política de Privacidad</u>
          </a>
          |
          <a href="/secure">
            <u>Prácticas de Navegación Segura</u>
          </a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">
          Diseño de <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
          <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">M-3892(Span.)-1125</p>  
      </div>
    </div>`,
  Pu: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6">
          Limitações, exclusões e períodos de espera podem ser aplicados.
        </p>
        <p class="mb-6 text-justify">
          As informações contidas neste site não representam um contrato de seguro, apenas fornecem informações gerais sobre o Ultra III (Apólice de Seguro de Vida Ajustável de Prêmio Flexível, FPAL132B), Prime (Apólice de Seguro de Vida Ajustável de Prêmio Flexível, FPAL17B) e o Index Pro IUL (Apólice de Seguro de Vida Universal Indexada de Prêmio Flexível Ajustável, FPAIUL20B). Para mais informações, contacte o seu consultor e consulte as condições específicas da apólice. Limitações da apólice, exclusões e períodos de espera e cláusulas adicionais podem ser aplicados.
        </p>
        <p class="text-center lg:text-left text-[14px]">
          ©2024 American Fidelity International Ltd. - Todos os direitos reservados
        </p>
        <p class="mb-6 text-center lg:text-left">
         
          <a href="/terms">
            <u>Termos de Uso</u>
          </a>
          |
          <a href="/privacy">
            <u>Política de Privacidade</u>
          </a>
          |
          <a href="/secure">
            <u>Práticas de Navegação Segura</u>
          </a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">
          Design por <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
          <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
        </p>  
        <p class="mb-6 text-center lg:text-left text-[14px]">M-3892-1125</p>
      </div>
    </div>`,
};

export const footerCodeConstSecure = {
  Eng: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6 text-justify">
          Products described on this website are available only to residents outside of the United States where rates are available (restrictions may apply in some countries). These plans are underwritten by American Fidelity International, Ltd. (AFIL).
        </p>
        <p class="mb-6 text-justify">
          This website only providers general information about AFIL products. Policy limitations, exclusions, deductibles, and waiting periods may apply.
        </p>
        <p class="text-center lg:text-left text-[14px]">
          American Fidelity International Ltd.
        </p>
        <p class="mb-6 text-center lg:text-left">
         
          <a href="/terms">
            <u>Terms of Use</u>
          </a>
          |
          <a href="/privacy">
            <u>Privacy Policy</u>
          </a>
          |
          <a href="/secure">
            <u>Secure Computing Practices</u>
          </a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">
          Design by <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
          <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
        </p>  
        <p class="mb-6 text-center lg:text-left text-[14px]">M-3893-1125</p>
      </div> 
    </div>`,
  Es: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6 text-justify">
          Pueden aplicarse limitaciones, exclusiones y períodos de espera.
        </p>
        <p class="mb-6 text-justify">
          La información de este sitio web no representa un contrato de seguro, solo proporciona información general sobre la Ultra III (Póliza de Seguro de Vida Ajustable de Prima Flexible, FPAL132B), Prime (Póliza de Seguro de Vida Ajustable de Prima Flexible, FPAL17B) y el Index Pro IUL (Póliza de Seguro de Vida Universal Indexada de Prima Flexible Ajustable, FPAIUL20B). Para obtener más información, póngase en contacto con su asesor y consulte las condiciones específicas de la póliza. Es posible que se apliquen limitaciones, exclusiones, períodos de espera y cláusulas adicionales.
        </p>
        <p class="text-center lg:text-left text-[14px]">
          American Fidelity International Ltd.  
        </p>
        <p class="mb-6 text-center lg:text-left">
         
          <a href="/terms">
            <u>Términos de Uso</u>
          </a>
          |
          <a href="/privacy">
            <u>Política de Privacidad</u>
          </a>
          |
          <a href="/secure">
            <u>Prácticas de Navegación Segura</u>
          </a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">
          Diseño de <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
          <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">M-3893(Span.)-1125</p>  
      </div>
    </div>`,
  Pu: `<div class="md:text-[#706F6F] text-[#B4B9C9]">
      <div class="mt-1 text-[12px] md:text-sm">
        <p class="mb-6">
          Limitações, exclusões e períodos de espera podem ser aplicados.
        </p>
        <p class="mb-6 text-justify">
          As informações contidas neste site não representam um contrato de seguro, apenas fornecem informações gerais sobre o Ultra III (Apólice de Seguro de Vida Ajustável de Prêmio Flexível, FPAL132B), Prime (Apólice de Seguro de Vida Ajustável de Prêmio Flexível, FPAL17B) e o Index Pro IUL (Apólice de Seguro de Vida Universal Indexada de Prêmio Flexível Ajustável, FPAIUL20B). Para mais informações, contacte o seu consultor e consulte as condições específicas da apólice. Limitações da apólice, exclusões e períodos de espera e cláusulas adicionais podem ser aplicados.
        </p>
        <p class="text-center lg:text-left text-[14px]">
          ©2024 American Fidelity International Ltd. - Todos os direitos reservados
        </p>
        <p class="mb-6 text-center lg:text-left">
         
          <a href="/terms">
            <u>Termos de Uso</u>
          </a>
          |
          <a href="/privacy">
            <u>Política de Privacidade</u>
          </a>
          |
          <a href="/secure">
            <u>Práticas de Navegação Segura</u>
          </a>
        </p>
        <p class="mb-6 text-center lg:text-left text-[14px]">
          Design por <a class="underline lg:no-underline" href="https://www.wemarkforyou.com/" target="_blank">Wemark</a> |
          <a href="https://www.wemarkforyou.com/" target="_blank">www.wemarkforyou.com</a>
        </p>  
        <p class="mb-6 text-center lg:text-left text-[14px]">M-3893-1125</p>
      </div>
    </div>`,
};
